import { CapacityCalculationParams } from "./type";

export function isBookingFull({
  nodeRequirePlayerCounts,
  nodeStandardCapacity,
  isGolfCourse,
  playersLength,
  groupSize = 1,
  bookingType,
  capacity,
}: CapacityCalculationParams): boolean {
  if (bookingType === "RequestBooking") {
    return capacity === playersLength;
  } else if (!nodeRequirePlayerCounts || isGolfCourse) {
    return nodeStandardCapacity === playersLength;
  }
  return playersLength === groupSize;
}
